import React from "react";

import { Button, IButtonProps, Tooltip } from "@amphore-dev/amphore-lib";
import { t } from "i18next";

import { ucFirst } from "@/utils/UStrings";

import { API_URL } from "@/constants/CEnv";

import { TSSOProviderName } from "@/types";

export interface IConnectWithButtonProps extends Omit<
	IButtonProps,
	"children"
> {
	provider: TSSOProviderName;
	onClick?: () => void;
}

export const ConnectWithButton: React.FC<IConnectWithButtonProps> = ({
	provider,
	onClick,
	...buttonProps
}) => {
	return (
		<Tooltip
			content={t(`auth.signInWith`, {
				provider: ucFirst(provider),
			})}
		>
			<Button
				color="white"
				variant="outline"
				type="button"
				className="outline-neutral-300"
				onClick={() => {
					onClick?.();
					window.location.assign(API_URL + `/auth/${provider}`);
				}}
				{...buttonProps}
			>
				<img
					src={`/assets/sso/${provider}.svg`}
					alt={ucFirst(provider)}
					className="h-4 w-4"
				/>
			</Button>
		</Tooltip>
	);
};
